export default {
  allMsg: '所有消息',
  systemMsg: '系统消息',
  personMsg: '人工消息',
  unread: '未读',
  seeDetail: '查看详情',
  read: '已读',
  replyNow: '现在回复',
  message: '站内信',
  operateSuccess: '操作成功',
  holder: {
    searchHolder: '包裹号/订单号/商品编号',
  },
  addAcBuy: '加入AcBuy Discord，赢取¥2000现金大奖！',
  joinNow: '点击这里加入',
  flatActivity: '平台活动',
  joinNow1: '立即加入',
  tips1: 'Acbuy官方Labubu抽奖活动',
  tips2: '超多Labubu盲盒免费送 & ZIMOMO全套等你拿',
}
